import React from 'react';
import './Select.scss';

import Select from 'react-select';

interface Props {
  id?: string;
  value: any;
  placeholder?: string;

  isMulti?: boolean;
  disabled?: boolean;
  options: any[];
  max?: number;

  wrapperStyle?: any;
  wrapperClass?: string;

  onChange: (val: any) => void;
}
const CustomSelect: React.FC<Props> = (props) => {
  
  const getOptForKey = (key: string) => {
    for (const opt of props.options) {
      if (opt.value === key) {
        return opt
      }
    }
    return null
  }

  const getSelectedValue = () => {
    if (props.isMulti) {
      return (props.value || []).map((item) => getOptForKey(item))
    }

    const key = props.value
    return getOptForKey(key)
  }

  const onChange = (val: any) => {
    if (props.isMulti) {
      const arr = val || []
      props.onChange(arr.map((item) => item.value))
    } else {
      props.onChange(val.value)
    }
  }

  const selected = getSelectedValue()
  return (
    <div className={props.wrapperClass || "custom-select-wrapper"} style={props.wrapperStyle}>
      <Select
        value={selected}
        onChange={onChange}
        options={(props.isMulti && props.max)
          ? (selected.length >= props.max ? [] : props.options)
          : props.options}
        disabled={props.disabled}
        placeholder={props.placeholder}

        isMulti={props.isMulti}
      />
    </div>
  );
}

export default CustomSelect;
